<template>
    <painel titulo="Brasil Mais - Participantes" icone="pi pi-key" :refreshFunction="atualizar" v-if="mostrarListagem">
        <tabela :data="participantes" dataKey="participanteId" :globalFilterFields="['codigo', 'uf', 'cnpj', 'ano', 'ciclo']" stateKey="dt-participantes">
            <template #botoes>
                <btn-inserir></btn-inserir>
            </template>
            <template #conteudo>
                <Column headerStyle="width: 3em">
                    <template #body="slotProps">
                        <div class="flex flex-nowrap">
                            <btn-emitir-certificado :participante="slotProps.data" @obterParticipantesAtualizados="atualizar()"></btn-emitir-certificado>
                            <btn-remover
                                :participante="slotProps.data"
                                class="ml-2"
                                @obterParticipantesAtualizados="obterParticipantes()"
                                v-if="!slotProps.data.certificadoEmitido"
                            ></btn-remover>
                        </div>
                    </template>
                </Column>
                <Column field="uf" header="UF" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.uf }}
                    </template>
                </Column>
                <Column field="ano" header="Ano" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.ano }}
                    </template>
                </Column>
                <Column field="ciclo" header="Ciclo" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.ciclo }}
                    </template>
                </Column>
                <Column field="cnpj" header="CNPJ" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.cnpj }}
                    </template>
                </Column>
                <Column field="nomeEmpresa" header="Nome da Empresa" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.nomeEmpresa }}
                    </template>
                </Column>
                <Column field="nomeDoAli" header="Nome do ALI" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.nomeDoAli }}
                    </template>
                </Column>
                <Column field="municipio" header="Município" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.municipio }}
                    </template>
                </Column>
                <Column field="escritorio" header="Escritório" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.escritorio }}
                    </template>
                </Column>
                <Column field="cnae" header="CNAE" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.cnae }}
                    </template>
                </Column>
                <Column field="descricaoCnae" header="Descrição CNAE" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.descricaoCnae }}
                    </template>
                </Column>
                <Column field="setor" header="Setor" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.setor }}
                    </template>
                </Column>
                <Column field="segmento" header="Segmento" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.segmento }}
                    </template>
                </Column>
                <Column field="porte" header="Porte" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.porte }}
                    </template>
                </Column>
                <Column field="medicao" header="Medição Inicial e Final" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.medicao }}
                    </template>
                </Column>
                <Column field="empresaDesistiu" header="Empresa Desistiu" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.empresaDesistiu }}
                    </template>
                </Column>
                <Column field="certificadoEmitido" header="Certificado Emitido" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.certificadoEmitido ? 'SIM' : 'NÃO' }}
                    </template>
                </Column>
            </template>
        </tabela>
    </painel>
    <router-view></router-view>
</template>

<script>
import ParticipantesService from './services';
import BtnEmitirCertificado from './BtnEmitirCertificado';
import BtnInserir from './BtnInserir';
import BtnRemover from './BtnRemover';

export default {
    components: {
        BtnEmitirCertificado,
        BtnInserir,
        BtnRemover,
    },

    data() {
        return {
            participantes: null,
        };
    },

    methods: {
        obterParticipantes() {
            this.$store.dispatch('addRequest');
            ParticipantesService.obterTodos().then((response) => {
                if (response?.success) {
                    this.participantes = response.data;
                } else {
                    this.participantes = null;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        atualizar() {
            this.obterParticipantes();
        },
    },

    mounted() {
        this.obterParticipantes();
    },

    computed: {
        mostrarListagem() {
            return this.$route.name === 'BrasilMais_Participantes';
        },
    },

    watch: {
        $route(to) {
            if (to.name === 'BrasilMais_Participantes') {
                if (this.$store.getters.atualizar) {
                    this.obterParticipantes();
                    this.$store.dispatch('setAtualizar', false);
                }
            }
        },
    },
};
</script>
